export default __webpack_public_path__ + "static/media/icon-call.7aeed2e7.svg";